import { useContext } from 'react';
import { SidebarContext } from './SidebarContext';

const useSidebar = () => useContext(SidebarContext);
export default useSidebar;
